import { Routes } from '@angular/router';
import { creditStatutsResolver } from '../credit/credit-statuts.resolver';

export const extractionRoutes: Routes = [
  {
    path: 'extraction',
    // Précharge les libellés/variants de statut une fois pour toute la feature
    // crédit — évite le flash "Statut N" le temps que `EtapeService` réponde.
    resolve: { _statuts: creditStatutsResolver },
    children: [
      {
        path: 'credit',
        loadComponent: () =>
          import('./pages/credit/credit-extraction.component').then(
            (m) => m.CreditExtractionComponent,
          ),
      },
      {
        path: 'asc',
        loadComponent: () =>
          import('./pages/asc/asc-extraction.component').then(
            (m) => m.AscExtractionComponent,
          ),
      },
      {
        path: 'garanties',
        loadComponent: () =>
          import('./pages/garanties/garanties-extraction.component').then(
            (m) => m.GarantiesExtractionComponent,
          ),
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'garanties',
      },
    ],
  },
];
